import { IkasCustomerReview } from ".";

export function initIkasCustomerReview(customerReview: IkasCustomerReview) {
  customerReview.images = customerReview.imageIds
    ? customerReview.imageIds.map((id) => ({ id, isVideo: false }))
    : null;
}
